import { render, staticRenderFns } from "./WorkHistoryAdd.vue?vue&type=template&id=2ca08cba"
import script from "./WorkHistoryAdd.vue?vue&type=script&lang=js"
export * from "./WorkHistoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports